// @flow

import React from 'react';
import PropTypes from 'prop-types';
import '@react/react-spectrum/page';
import Select from '@react/react-spectrum/Select';
import { withLocalization } from '@exc-ui/exc-sdk/dist/production/localization/withLocalization';
import {initializeEnvironmentVariables} from '../../utils/envUtil';
import { NOOP } from '../../constants/genericConstants';

class SolutionsDropdown extends React.Component {
  static propTypes = {
    /** Localization Strings*/
    localizationStrings: PropTypes.shape({
      /** Solution Dropdown placeholder text */
      dropDownPlaceholder: PropTypes.string
    }),
    /** i18n FormattedMessage*/
    FormattedMessage: PropTypes.func.isRequired
  };

  static defaultProps = {
    localizationStrings: {
      dropDownPlaceholder: 'Sign in Without Adobe Id'
    },
    FormattedMessage: NOOP
  };

  constructor(props) {
    super(props);
    this.envVar = initializeEnvironmentVariables();
  }
  handleChange(location) {
    window.location.href = location;
  }
  render() {
    const {
      localizationStrings,
      FormattedMessage
    } = this.props;
    const i18nFM = FormattedMessage;

    return (
      <Select
        className="login-product"
        onChange={this.handleChange}
        defaultValue=""
        options={[
          {
              label: 'Adobe Analytics',
              value: this.envVar.ANALYTICS_HOME_URL
          }, {
              label: 'Adobe Audience Manager',
              value: this.envVar.AUDIENCE_MANAGER_HOME_URL
          }, {
              label: 'Adobe Media Optimizer',
              value: this.envVar.MEDIA_OPTIMIZER_HOME_URL
          }, {
              label: 'Adobe Mobile Services',
              value: this.envVar.MOBILE_SERVICES_HOME_URL
          }, {
              label: 'Adobe Social',
              value: this.envVar.SOCIAL_HOME_URL
          }, {
              label: 'Dynamic Tag Management',
              value: this.envVar.DTM_HOME_URL
          }
      ]}
      placeholder={i18nFM({ messageId: 'dropDownPlaceholder',
        defaultMessage: localizationStrings.dropDownPlaceholder
      })}
      />
    );
  }
}

export default withLocalization(SolutionsDropdown);



// WEBPACK FOOTER //
// ./src/components/SolutionsDropdown/SolutionsDropdown.js